import { render } from "./SendResult.vue?vue&type=template&id=66b8c9dc&scoped=true&ts=true"
import script from "./SendResult.vue?vue&type=script&lang=ts"
export * from "./SendResult.vue?vue&type=script&lang=ts"

import "./SendResult.vue?vue&type=style&index=0&id=66b8c9dc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b8c9dc"]])

export default __exports__